<template>
  <div id="app">
    <selector></selector>
    <builder></builder>
    <p class="contact" v-html="footer"></p>
    <p class="contact"><strong style="color: #AAAAAA">Hinweis im allgemein öffentlichen Interesse:</strong><br>
      Da es immer wieder nicht verstanden wird: Dies ist ein satirisches Projekt welches von keinerlei Parteien oder
      sonstigen politischen Organisationen unterstützt wird.
      Dieses Projekt hat keine politische Agenda und ist nicht für die usergenerierten Inhalte die daraus hervorgehen verantwortlich.
      Sollten dargestellte Personen oder anderweitig in die Plakate involvierte Personen Probleme mit dieser Art der Repräsentation haben, möge eine E-Mail an <a href="mailto:gregor@vostrak.com">gregor@vostrak.com</a> erfolgen.
    </p>
    <datenschutzerklaerung></datenschutzerklaerung>
    <badge></badge>
  </div>
</template>

<script>

  import Builder from './components/Builder.vue';
  import Selector from './components/Selector.vue';
  import Badge from "./components/Badge";
  import Datenschutzerklaerung from "./components/Datenschutzerklaerung";


  export default {
    name: 'app',
    components: {
      Builder,
      Selector,
      Badge,
      Datenschutzerklaerung
    },
    computed: {
      footer() {
        return 'made by Gregor Vostrak (<a href="https://twitter.com/onatcer">@onatcer</a>)  <br> contact, feedback etc. via twitter or <a href="mailto:gregor@vostrak.at">gregor@vostrak.at</a>'
      }
    }
  }
</script>

<style>


  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    position: relative;
    max-width: 1000px;
    width: 90%;
    margin: 0 auto;
    margin-top: 40px;
  }

  .contact {
    color: #BBB;
    margin-bottom: 50px;
  }

  .contact a {
    color: #C86DD7;

  }
</style>



// WEBPACK FOOTER //
// App.vue?3800a38d